import React from 'react';
import Icon from '@mdi/react';
import { Stack } from '@mui/material';

/**
 * Icon component for SimpleTreeView's expand/collapse buttons.
 */
export default ({ path, withWrap, size }: { path: string; withWrap?: boolean; size?: string }) =>
    () => {
        return withWrap ? (
            <Stack
                sx={{
                    alignItems: 'center',
                }}
            >
                <Icon path={path} size={size || 1} />
            </Stack>
        ) : (
            <Icon path={path} size={size || 1} />
        );
    };
